<template>
  <div class="row form-stylizer">
    <div class="col-12">
      <b-form-group id="statut-group" label="Statut" label-for="statut-input">
        <b-form-checkbox v-model="form.etat" name="statut-input" switch>
          <span class="statut-etat"
            >({{ form.etat ? "En cours" : "Terminé" }})</span
          >
        </b-form-checkbox>
      </b-form-group>
    </div>
    <div class="col-6">

      <div
        id="numero-affaire-group"
      >
        <b-form-input
          v-model="form.numeroAffaire"
          id="numero-affaire-input"
          type="text"
          placeholder="Numéro d'affaire"
        >
        </b-form-input>
      </div>
      <div
        id="nom-contact-group"
      >
        <b-form-input
          v-model="form.contactNom"
          id="nom-contact-input"
          type="text"
          placeholder="Nom du contact"
        >
        </b-form-input>
      </div>
      <div
        id="email1-contact-group"
      >
        <b-form-input
          v-model="form.contactEmail"
          id="email1-contact-input"
          type="email"
          placeholder="Email du contact"
        >
        </b-form-input>
      </div>
      <div
        id="tel1-contact-group"
      >
        <b-form-input
          v-model="form.contactTel1"
          id="tel1-contact-input"
          type="text"
          placeholder="Téléphone"
        >
        </b-form-input>
      </div>
      <div
        id="tel2-contact-group"
      >
        <b-form-input
          v-model="form.contactTel2"
          id="tel2-contact-input"
          type="text"
          placeholder="Mobile"
        >
        </b-form-input>
      </div>
    </div>

    <div class="col-6">
      <div
        id="adresse-client-group"
      >
        <b-form-input
          v-model="form.adresse"
          id="adresse-client-input"
          type="text"
          placeholder="Adresse"
        >
        </b-form-input>
      </div>
      <div
        id="complementAdresse-client-group"
      >
        <b-form-input
          v-model="form.complementAdresse"
          id="complementAdresse-client-input"
          type="text"
          placeholder="Complément d' adresse"
        >
        </b-form-input>
      </div>
      <div class="row">
        <div
          id="code-postal-group"
          class="col-md-4"
        >
          <b-form-input
            v-model="form.codePostal"
            id="code-postal-input"
            type="number"
            name="code-postal-input"
            @keyup="codePostalHandleChange"
            v-validate="'required'"
            placeholder="CP *"
          >
          </b-form-input>
        </div>
        <div
          id="departement-group"
          class="col-md-8"
        >
          <b-form-input
            v-model="form.departement"
            id="departement-input"
            type="text"
            readonly
            required
            placeholder="Département *"
          >
          </b-form-input>
        </div>
      </div>
      <div id="ville-group">
        <b-form-input v-model="form.ville" id="ville-input" type="text" placeholder="Ville">
        </b-form-input>
      </div>
      <b-form-group
        id="type-operation-group"
        label="Type d'opération *"
        label-for="type-operation-input"
      >
        <div
          class="custom-control custom-control-inline custom-checkbox"
          v-for="(optionTypeOperation, index) in optionsTypeOperation"
          :key="optionTypeOperation.id"
        >
          <input
            :id="'type-operation-input' + optionTypeOperation.id"
            type="checkbox"
            name="typeOperation"
            autocomplete="off"
            class="custom-control-input"
            v-model="form.typeOperations"
            :value="optionTypeOperation.id"
            v-validate="index === 1 ? 'required' : null"
          />
          <label
            :for="'type-operation-input' + optionTypeOperation.id"
            class="custom-control-label"
            >{{ optionTypeOperation.nom }}</label
          >
        </div>
      </b-form-group>
    </div>
    <hr />
    <div class="col-12">
      <div class="button-wrap validation-button d-flex justify-content-end">
        <p class="obligatoire">* Champs obligatoire</p>
        <b-button variant="outline-primary" @click.prevent="previousStep"
          >Annuler</b-button
        >
        <b-button
          v-if="!this.pending()"
          type="button"
          variant="primary"
          class="lg-btn"
          @click="handleSubmitForm"
        >Créer le projet
        </b-button>
        <b-button v-else class="txt-btn" variant="primary">
          <b-spinner small type="grow"></b-spinner> En cours...
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: ['formData'],
  data () {
    return {
      form: {
        contactNom: '',
        contactEmail: '',
        contactTel1: '',
        contactTel2: '',
        adresse: '',
        complementAdresse: '',
        codePostal: '',
        ville: '',
        departement: '',
        societe: this.userSocieteId(),
        typeOperations: [],
        etat: true,
        terrainOccupe: false
      },
      optionsTypeOperation: [],
      numeroAffaire: ''
    }
  },
  mounted () {
    this.getTypeOperation().then(resp => {
      this.optionsTypeOperation = resp.items
    })
  },
  methods: {
    ...mapActions(['setMessage', 'getDepartement', 'getDepartements', 'getTypeOperation', 'addProject', 'setPending']),
    ...mapGetters(['userSocieteId', 'pending']),
    codePostalHandleChange (e) {
      if (this.form.codePostal.length >= 5) {
        this.form.codePostal = this.form.codePostal.slice(0, 5)
        if (this.form.codePostal.slice(0, 2) !== '97') {
          this.getDepartement(this.form.codePostal.slice(0, 2)).then((resp) => {
            if (resp[0]) {
              this.form.departement = resp[0].nom
              return
            }
            // this.$toaster.error('Code postal inéxistant')
            this.setMessage('Code postal inéxistant')
          })
          return
        }

        this.getDepartement(this.form.codePostal.slice(0, 3)).then((resp) => {
          if (resp[0]) {
            this.form.departement = resp[0].nom
          }
        })
      }
    },
    previousStep () {
      this.$emit('finalStep', 1)
    },
    handleSubmitForm () {
      this.$validator
        .validateAll()
        .then((response) => {
          if (!response) {
            // this.$toaster.error('Veuillez completer les champs obligatoires')
            this.setMessage('Code postal inéxistant')
            return
          }
          this.formatAndSubmitFormData()
        })
        .catch(function (e) {
          // Catch errors
          console.log('error handleSubmitForm step 2', e)
        })
    },
    formatAndSubmitFormData () {
      this.setPending(true)
      this.form.etat = this.form.etat ? 1 : 3
      this.addProject({ ...this.formData, ...this.form }).then(resp => {
        this.setMessage('Projet créé')
        this.$emit('afterSubmitForm', resp.id)
      }, err => {
        // this.$toaster.error(err)
        this.setMessage(err)
      }).finally(_ => {
        this.setPending(false)
      })
    }
  }
}
</script>
<style lang="scss">
.h2-title {
  font-size: 18px;
  color: #2b3085;
  margin-bottom: 25px;
  font-weight: 600;
  font-family: "Open sans";
}
#type-operation-group {
  label {
    font-size: 13px;
  }
}

#statut-group {
  display: flex;
  margin-bottom: 15px;
  label {
    margin-right: 15px;
  }
  .custom-switch .custom-control-label::before {
    border-radius: 2px;
    background-color: #fff;
    border: 1px solid #2b3085;
    top: 1px;
  }
  .custom-switch .custom-control-label::after {
    border-radius: 0px;
    background-color: #2b3085;
    top: 2px;
    width: calc(1rem - 2px);
    height: calc(1rem - 2px);
        left: calc(-2.25rem + 1px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/creationProjectModal/stepTwo.vue